/**
 * 1.8.4 §3 (D-1.8.4-3) — the day as a List (by time) or a Grid (a column per program): each person's choice,
 * remembered on this device (localStorage). A device that keeps nothing (a private window, blocked site data) shows
 * the List and still lets a person switch for the visit.
 */
import { useCallback, useState } from 'react';

export const VIEW_KEY = 'abf.today184.view';
export type DayView = 'list' | 'grid';

function read(): DayView {
  try {
    return localStorage.getItem(VIEW_KEY) === 'grid' ? 'grid' : 'list';
  } catch {
    return 'list';
  }
}

export function useView(): [DayView, (v: DayView) => void] {
  const [view, setView] = useState<DayView>(read);
  const choose = useCallback((v: DayView) => {
    setView(v);
    try {
      localStorage.setItem(VIEW_KEY, v);
    } catch {
      /* the device keeps nothing: the choice lasts for this visit */
    }
  }, []);
  return [view, choose];
}
